import React, { useEffect, useCallback, useRef } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DialogBox, Button } from 'xm-spark';
import classnames from 'classnames';
import { restartSession } from 'services/sessionService';
import { XMATTERS_SIGN_OUT_URL } from 'xm-constants/urls';

import style from './SessionExpiredDialog.module.scss';

export default function SessionExpiredDialog({ isOpen, isSamlEnabled }) {
  const targetWindow = useRef();
  const triggerLoggedInEvtListener = useCallback(
    event => {
      if (event?.data?.type === 'LOGGED_IN' && isOpen) {
        targetWindow.current?.close();
        restartSession();
      }
    },
    [isOpen, targetWindow.current],
  );
  const samlRelogin = () => {
    targetWindow.current = window.open(`https://${window.location.host}`);
  };
  const handleRelogin = () => {
    if (isSamlEnabled) {
      samlRelogin();
    } else {
      const sep = XMATTERS_SIGN_OUT_URL.includes('?') ? '&' : '?';
      const redirectUrl = `${XMATTERS_SIGN_OUT_URL}${sep}refererURL=${encodeURIComponent(
        window.location.href,
      )}`;
      window.location.href = redirectUrl;
    }
  };
  const onClose = () => {
    window.location.href = XMATTERS_SIGN_OUT_URL;
  };
  useEffect(() => {
    window.addEventListener('message', triggerLoggedInEvtListener);
    return () =>
      window.removeEventListener('message', triggerLoggedInEvtListener);
  }, [triggerLoggedInEvtListener]);

  return (
    <DialogBox
      simpleStyle
      isOpen={isOpen}
      onClose={onClose}
      titleText={<FormattedMessage id="SESSION_EXPIRED_HEADING" />}
      centerButtons={[
        <Button
          className={classnames('button-primary')}
          key="login"
          onClick={handleRelogin}
          data-testid="end-session"
        >
          <FormattedMessage id={isSamlEnabled ? 'LOG_IN_WITH_SSO' : 'LOG_IN'} />
        </Button>,
      ]}
      classes={{
        wrap: classnames(style.modalDialog),
        header: style.header,
        title: style.title,
        buttons: style.buttons,
        content: style.content,
      }}
    >
      <FormattedMessage
        id={isSamlEnabled ? 'RELOGIN_SSO_DESCRIPTION' : 'RELOGIN_DESCRIPTION'}
      />
    </DialogBox>
  );
}

SessionExpiredDialog.displayName = 'SessionExpiredDialog';

SessionExpiredDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isSamlEnabled: PropTypes.bool.isRequired,
};
